import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

export const FAQSection = () => {
  const { t } = useTranslation();
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.2 });

  const faqs = t('faq.questions', { returnObjects: true });

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-black relative overflow-hidden">
      {/* Cross-hatch pattern - Reduced on mobile */}
      <div className="absolute inset-0 opacity-[0.02] hidden sm:block" style={{
        backgroundImage: 'linear-gradient(45deg, transparent 48%, white 48%, white 52%, transparent 52%), linear-gradient(-45deg, transparent 48%, white 48%, white 52%, transparent 52%)',
        backgroundSize: '40px 40px',
      }}></div>

      {/* Decorative elements - Hidden on mobile */}
      <div className="absolute top-1/2 left-0 w-96 h-96 bg-white/[0.02] rounded-full blur-3xl hidden md:block"></div>
      <div className="absolute top-1/2 right-0 w-96 h-96 bg-white/[0.02] rounded-full blur-3xl hidden md:block"></div>

      <div className="container mx-auto max-w-4xl relative z-10">
        <div
          ref={ref}
          className={`transform transition-all duration-1000 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
          }`}
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 text-center text-white">
            {t('faq.title')}{' '}
            <span className="text-gray-500">
              {t('faq.titleGray')}
            </span>
          </h2>

          <p className="text-base sm:text-lg md:text-xl text-gray-500 text-center mb-10 sm:mb-12 md:mb-16 max-w-3xl mx-auto px-4">
            {t('faq.subtitle')}
          </p>

          <Accordion type="single" collapsible className="space-y-3 sm:space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border border-zinc-800 rounded-none bg-zinc-950 overflow-hidden hover:border-zinc-700 transition-colors"
              >
                <AccordionTrigger className="px-4 sm:px-6 py-3 sm:py-4 text-left text-white hover:text-gray-300 transition-colors">
                  <span className="text-base sm:text-lg font-semibold pr-4">{faq.question}</span>
                </AccordionTrigger>
                <AccordionContent className="px-4 sm:px-6 pb-3 sm:pb-4 text-sm sm:text-base text-gray-500 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};